import React, { useEffect } from "react";
import RelatedPost from "./RelatedPost";
import AiImage from '../../assets/images/ai.jpg'
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getRelatedBlogs } from "../../features/relatedBlogs/relatedBlogsApi";
import { fetchRelatedBlogs } from "../../features/relatedBlogs/relatedBlogsSlice";

const RelatedPosts = ({id, tags}) => {
    const dispatch = useDispatch();
    const {blogs, isLoading, isError, error} = useSelector((state) => state.relatedBlogs)

    useEffect(() => {
        dispatch(fetchRelatedBlogs({id, tags}))
    },[dispatch, tags, id])


    let content;

    if(isLoading){
        content = <div className='text-xl'>Loading...</div>
    }

    if(!isLoading && isError){
        content = <div>{error}</div>
    }

    if(!isLoading && !isError && blogs.length > 0){
        content = blogs.map((blog) => <RelatedPost key={blog.id} blog={blog}/>)
    }

  return (
    <aside>
      <h4 className="mb-4 text-xl font-medium" id="lws-relatedPosts">
        Related Posts
      </h4>
      <div className="space-y-4 related-post-container">
        {content}
      </div>
    </aside>
  );
};

export default RelatedPosts;
